module.exports = __webpack_public_path__ + "static/media/shop_slider_1.3cc5306e.svg";